import React, { ReactElement, ReactNode } from 'react';

export const HeaderAppName = ({
  children,
  hidePipe = false,
}: {
  children: ReactNode;
  hidePipe: boolean;
}): ReactElement => {
  return (
    <div className="lmig-FloatingHeader-appName">
      {!hidePipe && <div className="lmig-FloatingHeader-appName-pipe" aria-hidden />}
      <div className="lmig-FloatingHeader-appName-content">{children}</div>
    </div>
  );
};
